import type { Dispatch, SetStateAction } from 'react';
import { useEffect } from 'react';

import { StringParam, useQueryParams } from 'use-query-params';

import type { GridSortModel } from '@packages/fenrir/components';
import {
  GridSelectOperator,
  type GridFilterModel,
} from '@packages/fenrir/components';

type useAllRisksSummaryFilterProps = {
  setFilterModel: Dispatch<SetStateAction<GridFilterModel>>;
  setSortModel: Dispatch<SetStateAction<GridSortModel>>;
};

export const useAllRisksSummaryFilter = ({
  setFilterModel,
  setSortModel,
}: useAllRisksSummaryFilterProps) => {
  const [summaryQueryParam, setSummaryQueryParam] = useQueryParams({
    summaryFilter: StringParam,
  });

  useEffect(() => {
    if (summaryQueryParam.summaryFilter) {
      setSummaryQueryParam({}, 'replace');
      setFilterModel({
        items: [
          {
            id: 1,
            field: 'status',
            operator: GridSelectOperator.Is,
            value: 'unresolved',
          },
          {
            id: 2,
            field: 'severity',
            operator: GridSelectOperator.isAnyOf,
            value: [summaryQueryParam.summaryFilter],
          },
        ],
      });
      setSortModel([{ field: 'score', sort: 'desc' }]);
    }
  }, [summaryQueryParam, setSummaryQueryParam, setFilterModel, setSortModel]);
};
